var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask, _rect2, _circle2, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.5891,
    y: 197.959,
    width: 387,
    height: 197,
    rx: 9,
    transform: "rotate(-15.185 51.5891 197.959)",
    fill: "#F0FFF1",
    stroke: "#231942",
    strokeWidth: 14
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 272.784,
    cy: 232.949,
    r: 68.5,
    transform: "rotate(-15.185 272.784 232.949)",
    stroke: "#231942",
    strokeWidth: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.6775 246.807C95.3441 249.263 97.8758 250.714 100.332 250.047C102.788 249.38 104.239 246.849 103.573 244.392L94.6775 246.807ZM95.449 214.462L94.2419 210.014L85.3468 212.428L86.5539 216.876L95.449 214.462ZM103.573 244.392L95.449 214.462L86.5539 216.876L94.6775 246.807L103.573 244.392Z",
    fill: "#231942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7938 211.22L85.346 212.426L87.7584 221.322L92.2062 220.116L89.7938 211.22ZM122.532 211.892C124.988 211.226 126.44 208.694 125.774 206.238C125.107 203.781 122.576 202.33 120.12 202.996L122.532 211.892ZM92.2062 220.116L122.532 211.892L120.12 202.996L89.7938 211.22L92.2062 220.116Z",
    fill: "#231942"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.623 323.998C114.956 321.542 116.407 319.01 118.863 318.343C121.32 317.677 123.851 319.128 124.518 321.584L115.623 323.998ZM132.641 351.515L133.849 355.962L124.953 358.376L123.746 353.929L132.641 351.515ZM124.518 321.584L132.641 351.515L123.746 353.929L115.623 323.998L124.518 321.584Z",
    fill: "#231942"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.403 357.17L124.956 358.378L122.54 349.483L126.987 348.275L129.403 357.17ZM157.31 340.039C159.766 339.372 162.298 340.822 162.965 343.278C163.632 345.734 162.182 348.266 159.726 348.933L157.31 340.039ZM126.987 348.275L157.31 340.039L159.726 348.933L129.403 357.17L126.987 348.275Z",
    fill: "#231942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M411.838 160.725C412.505 163.181 411.054 165.713 408.598 166.379C406.141 167.046 403.61 165.595 402.943 163.139L411.838 160.725ZM394.82 133.208L393.612 128.761L402.507 126.346L403.715 130.794L394.82 133.208ZM402.943 163.139L394.82 133.208L403.715 130.794L411.838 160.725L402.943 163.139Z",
    fill: "#231942"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M398.058 127.553L402.505 126.345L404.921 135.239L400.474 136.447L398.058 127.553ZM370.151 144.684C367.695 145.351 365.163 143.901 364.496 141.445C363.829 138.989 365.279 136.457 367.735 135.789L370.151 144.684ZM400.474 136.447L370.151 144.684L367.735 135.789L398.058 127.553L400.474 136.447Z",
    fill: "#231942"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M432.791 237.916C432.125 235.46 429.593 234.009 427.137 234.676C424.68 235.342 423.23 237.874 423.896 240.33L432.791 237.916ZM432.02 270.261L433.227 274.708L442.122 272.294L440.915 267.847L432.02 270.261ZM423.896 240.33L432.02 270.261L440.915 267.847L432.791 237.916L423.896 240.33Z",
    fill: "#231942"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M437.675 273.502L442.123 272.296L439.71 263.401L435.263 264.607L437.675 273.502ZM404.937 272.831C402.48 273.497 401.029 276.028 401.695 278.485C402.361 280.941 404.893 282.393 407.349 281.726L404.937 272.831ZM435.263 264.607L404.937 272.831L407.349 281.726L437.675 273.502L435.263 264.607Z",
    fill: "#231942"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.945 207.125L287.304 194.814L288.79 200.289L271.675 204.935C271.675 204.935 278.663 209.153 279.673 212.877L291.297 209.722L292.664 214.759L281.534 217.78C281.534 217.78 283.922 235.381 262.317 240.116L295.862 260.784L285.475 263.603L251.945 243.966L250.423 238.359C250.423 238.359 263.428 235.205 268.6 229.804C272.776 225.425 271.633 223.76 271.603 221.886C271.573 221.189 270.862 220.724 270.12 220.925L247.367 227.101L246 222.063L269.298 215.739C269.792 215.605 269.97 215.086 269.616 214.759C268.162 213.32 264.507 210.22 260.706 210.499C255.768 210.899 243.788 213.915 243.788 213.915L241.945 207.125Z",
    fill: "#231942"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_3075_3038",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 134,
    width: 412,
    height: 216.788,
    rx: 16.4389
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 134,
    width: 412,
    height: 216.788,
    rx: 16.4389,
    fill: "#F0FFF1",
    stroke: "#231942",
    strokeWidth: 34,
    mask: "url(#path-12-inside-1_3075_3038)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.483,
    cy: 242.909,
    r: 66.5299,
    stroke: "#231942",
    strokeWidth: 19
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8984 203.568C89.8984 208.263 93.704 212.068 98.3984 212.068C103.093 212.068 106.898 208.263 106.898 203.568H89.8984ZM106.898 173.043V164.543H89.8984V173.043H106.898ZM106.898 203.568V173.043H89.8984V203.568H106.898Z",
    fill: "#231942"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4002 164.543L89.9002 164.541L89.8967 181.541L98.3967 181.543L98.4002 164.543ZM129.323 181.549C134.018 181.55 137.824 177.746 137.825 173.051C137.826 168.357 134.021 164.55 129.327 164.549L129.323 181.549ZM98.3967 181.543L129.323 181.549L129.327 164.549L98.4002 164.543L98.3967 181.543Z",
    fill: "#231942"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8984 282.293C89.8984 277.599 93.704 273.793 98.3984 273.793C103.093 273.793 106.898 277.599 106.898 282.293H89.8984ZM106.898 312.818V321.318H89.8984V312.818H106.898ZM106.898 282.293V312.818H89.8984V282.293H106.898Z",
    fill: "#231942"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4002 321.318L89.9002 321.32L89.8967 304.32L98.3967 304.318L98.4002 321.318ZM129.323 304.312C134.018 304.311 137.824 308.116 137.825 312.81C137.826 317.505 134.021 321.311 129.327 321.312L129.323 304.312ZM98.3967 304.318L129.323 304.312L129.327 321.312L98.4002 321.318L98.3967 304.318Z",
    fill: "#231942"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M421.281 203.568C421.281 208.263 417.476 212.068 412.781 212.068C408.087 212.068 404.281 208.263 404.281 203.568H421.281ZM404.281 173.043V164.543H421.281V173.043H404.281ZM404.281 203.568V173.043H421.281V203.568H404.281Z",
    fill: "#231942"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M412.779 164.543L421.279 164.541L421.283 181.541L412.783 181.543L412.779 164.543ZM381.856 181.549C377.162 181.55 373.356 177.746 373.355 173.051C373.354 168.357 377.158 164.55 381.853 164.549L381.856 181.549ZM412.783 181.543L381.856 181.549L381.853 164.549L412.779 164.543L412.783 181.543Z",
    fill: "#231942"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M421.281 282.293C421.281 277.599 417.476 273.793 412.781 273.793C408.087 273.793 404.281 277.599 404.281 282.293H421.281ZM404.281 312.818V321.318H421.281V312.818H404.281ZM404.281 282.293V312.818H421.281V282.293H404.281Z",
    fill: "#231942"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M412.779 321.318L421.279 321.32L421.283 304.32L412.783 304.318L412.779 321.318ZM381.856 304.312C377.162 304.311 373.356 308.116 373.355 312.81C373.354 317.505 377.158 321.311 381.853 321.312L381.856 304.312ZM412.783 304.318L381.856 304.312L381.853 321.312L412.779 321.318L412.783 304.318Z",
    fill: "#231942"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.859 209.002H276.149V214.831H257.928C257.928 214.831 263.721 220.894 263.721 224.859H276.095V230.221H264.247C264.247 230.221 261.877 248.316 239.181 247.197L266.881 276.718H255.822L227.859 248.223V242.254C227.859 242.254 241.604 242.626 248.186 238.663C253.505 235.445 252.82 233.486 253.294 231.62C253.452 230.921 252.872 230.268 252.082 230.268H227.859V224.905H252.662C253.188 224.905 253.505 224.438 253.242 224.019C252.188 222.2 249.397 218.142 245.553 217.396C240.55 216.464 227.859 216.23 227.859 216.23V209.002Z",
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/cms.4b586796d96ab16868b7ba9afe504364.svg";
export { ForwardRef as ReactComponent };